exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".newsletter-action__content__step__first-slide .form-group span{padding:0;position:absolute;top:60px}.newsletter-action__content__step__first-slide .form-group span .error-message{font-size:.7em!important;margin:0 0 1.5em!important}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-40294cb2","scoped":false,"hasInlineConfig":true}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/site/components/newsletter-widget/subscribe-slide.vue
// module id = 2cXk
// module chunks = 0